<template>

        <div :id="problem.id" :class="'accordion-section'+ (problem.open?' active':'')" v-if="problem.data">
          <div class="accordion-header" @click="problem.open = !problem.open">
            <div class="accordion-title">
              <i :class="'bi '+ problem.ico"></i> {{ problem.name }}
              <span :class="'accordion-badge ' + (problem.count > 0?'success':'critical')">{{ problem.count }} workers</span>
            </div>
            <div class="accordion-icon">▼</div>
          </div>
          <div :class="'accordion-content'+ (problem.open?' active':'')">
            <table class="data-table">
              <thead>
              <tr>
                <th>Очередь</th>
                <th>Worker'ы</th>
                <th>Кол-во</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(info, queue_name) in problem.data.queue_stats?.queue_distribution">
                <td><code><strong>{{ queue_name }}</strong></code></td>
                <td><span v-for="w in info">{{ w }}, </span></td>
                <td>{{ info.length }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>


</template>

<script>

export default {
  name: 'QueuesInfo',
  data() {
    return {}
  },
  props: {
    problem: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">

</style>